import { CircularProgress } from '@mui/material';
import styles from './index.module.css' 

const ButtonLoader=()=>{
    return(
        <CircularProgress  thickness={7}  className={styles.circularProgress} color="inherit" />
    )
}
export default ButtonLoader;